import { Action, CalendarState } from 'redux/reducers/interfaces'
import * as actions from 'redux/actions'
import { createReducer } from 'typesafe-actions'

const initialState: CalendarState = {
    isAutoSave: false,
    isSaveSuccess: false,
    isApproveSuccess: false,
    isCreateSuccess: false,
    isApprovedCalendarModifyError: false,
    wasSaved: false,
    types: [],
    list: [],
    calendarId: ''
}

export const calendarsReducer = createReducer<CalendarState, Action>(initialState)
    //saveCalendar
    .handleAction(actions.saveCalendar.request, (state) => ({
        ...state,
        isSaveSuccess: false,
        isApprovedCalendarModifyError: false
    }))
    .handleAction(actions.saveCalendar.success, (state, action) => ({
        ...state,
        isAutoSave: action.payload.isAutoSave,
        isSaveSuccess: true,
        calendarId: action.payload.calendarId,
        wasSaved: true
    }))
    .handleAction(actions.saveCalendar.cancel, (state) => ({
        ...state,
        isSaveSuccess: false
    }))
    .handleAction(actions.saveCalendar.failure, (state) => ({
        ...state,
        isApprovedCalendarModifyError: true
    }))
    //approveCalendar
    .handleAction(actions.approveCalendar.request, (state) => ({
        ...state,
        isApproveSuccess: false
    }))
    .handleAction(actions.approveCalendar.success, (state, action) => ({
        ...state,
        calendarId: action.payload.calendarId,
        isApproveSuccess: true
    }))
    .handleAction(actions.approveCalendar.cancel, (state) => ({
        ...state,
        isApproveSuccess: false
    }))
    //createCalendar
    .handleAction(actions.createCalendar.request, (state) => ({
        ...state,
        isCreateSuccess: false
    }))
    .handleAction(actions.createCalendar.success, (state, action) => ({
        ...state,
        calendarId: action.payload.calendarId,
        isCreateSuccess: true
    }))
    .handleAction(actions.createCalendar.cancel, (state) => ({
        ...state,
        isCreateSuccess: false,
        wasSaved: false
    }))
    //getCalendarTypes
    .handleAction(actions.getCalendarTypes.success, (state, action) => ({
        ...state,
        types: action.payload
    }))
    //getCalendarList
    .handleAction(actions.getCalendarList.success, (state, action) => ({
        ...state,
        list: action.payload
    }))
    //setCalendarId
    .handleAction(actions.setCalendarId, (state, action) => ({
        ...state,
        calendarId: action.payload
    }))
